import React, { useMemo } from "react";

type ClavaButtonProps = {
  secondary?: boolean;
  danger?: boolean;
  disabled?: boolean;
  size?: "fit" | "full";
  pill?: boolean;
  onClick: () => void;
};

const ClavaButton: React.FC<React.PropsWithChildren<ClavaButtonProps>> = ({
  onClick,
  secondary,
  danger,
  disabled,
  size,
  pill,
  children,
}) => {
  const btnClasses = useMemo(() => {
    let style = "";
    const radius = pill ? "rounded-full" : "rounded-2xl";
    if (disabled) {
      style +=
        `${radius} py-2 px-8 flex flex-row items-center justify-center border-0 text-center bg-transparent text-primary opacity-60`;
    } else if (danger) {
      style +=
        `${radius} py-2 px-8 flex flex-row items-center justify-center border-0 bg-loss text-center active:bg-loss hover:bg-loss text-white`;
    } else if (secondary)
      style +=
        `${radius} py-2 px-8 flex flex-row items-center justify-center border-primary text-center bg-transparent active:bg-btn-active hover:bg-btn-active text-primary active:text-font-dark hover:text-font-dark`;
    else
      style +=
        `${radius} py-2 px-8 flex flex-row items-center justify-center border-0 bg-primary text-center active:bg-btn-active hover:bg-btn-active text-font-dark`;
    if (size === "full") {
      style += " w-full";
    } else {
      style += " w-fit";
    }
    return style;
  }, [disabled, size, secondary, danger, pill]);
  return (
    <button className={btnClasses} onClick={onClick} type="button">
      {children}
    </button>
  );
};

export default ClavaButton;
